export const FIFTY_MB_FILE_SIZE_VALUE = 50 * 1024 * 1024;